import * as ApiClient from "./api_client";
import { View } from "./view";
import { ViewManager } from "./view_manager";
import { THRESHOLDS } from "./thresholds";
import * as Visualisations from "./visualisations/index";

const viewManager = new ViewManager();

export function createView(id, element) {
  return new View(id, viewManager.renderer, element);
}

export function get(id) {
  return viewManager.getView(id);
}

export function add(...views) {
  for (const view of views) {
    viewManager.addView(view);
  }
}

export function remove(...views) {
  for (const view of views) {
    viewManager.removeView(view);
  }
}

export function dispose() {
  viewManager.dispose();
}

export function getRenderer() {
  return viewManager.renderer;
}

export function classifyValidationScore(data, immediate = false) {
  const scoreKey = immediate ? "scoreImmediate" : "scoreRestorative";
  const score = data?.scanAnalysis[scoreKey];

  if (!data || !score) throw new Error("Invalid input data");

  if (score < THRESHOLDS.CONSIDER_RESCAN) {
    return "Fail";
  }
  if (score < THRESHOLDS.PASS) {
    return "Consider Rescan";
  }
  return "Pass";
}

export { ApiClient, View, Visualisations };
